import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Icon, IconButton, TextField, Grid, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class StudentGradebook extends Component {
    state = {
        current_tab: 0,
        student_id: 0,
        company_course_id: 0,
    }

    constructor(props) {
        super(props);

        const company_course_id = this.props.match.params.company_course_id;
        const auth = this.props.auth;

        let student_id = this.props.match.params.student_id || 0;
        if (student_id === 0 && auth.user.role === "student") {
            student_id = auth.user.data.role_info.link_id;
        }

        this.state = {
            ...this.state,
            student_id: student_id,
            company_course_id: company_course_id,
        }
    }

    componentDidMount = () => {
        const { student_id, company_course_id } = this.state;

        this.props.getStudentGradebook(company_course_id, student_id);
    }

    handleRowClick = (event_info) => {
        const { student_quiz_id, student_assignment_id, company_calendar_event_id } = event_info;
        const { auth } = this.props;

        if (auth.user.role === "student") {
            if (student_quiz_id) {
                this.props.history.push(`/quiz/score/${student_quiz_id}`);
            } else if (student_assignment_id) {
                this.props.history.push(`/assignment/student/${company_calendar_event_id}`);
            }
        } else {
            if (student_quiz_id) {
                this.props.history.push(`/quiz/grader/${student_quiz_id}`);
            } else if (student_assignment_id) {
                this.props.history.push(`/assignment/grader/${student_assignment_id}`);
            }
        }
    }

    handleScoreChange = gradebook_detail_id => event => {
        let value = event.target.value;

        this.props.updateGradebookScore(gradebook_detail_id, value);
    }

    handleScoreBlur = gradebook_detail_id => event => {
        let value = Number(event.target.value);
        if (isNaN(value)) {
            value = Number(0.00).toFixed(1);
        } else {
            value = Math.abs(value).toFixed(1)
        }

        this.props.updateGradebookScore(gradebook_detail_id, value);
        this.props.saveGradebookScore(gradebook_detail_id, value);
    }

    handleEventClick = (event) => {
        if (event.ProgressBlockColor === '#3D9970') {
            return this.props.history.push(`/${event.EventType.toLowerCase()}/grader/${event.StudentEventID}`)
        }
        else return null
    }

    getStatusColumn = (row) => {
        return (

            <Tooltip key={row.company_calendar_event_id} title={
                <React.Fragment>
                    <div>{row.EventName}</div>
                    <div>{row.unscheduled ? 'Self-Paced' : row.EventDate}</div>
                    <div>{row.EventStatus}</div>
                    <div>{Number(row.EventScore).toFixed(1)}</div>
                </React.Fragment>
            }
                placement="top"
            >
                {/* border: `2px solid ${row.EventColor}` */}
                <div
                    onClick={() => this.handleEventClick(row)}
                    style={{ backgroundColor: row.ProgressBlockColor, height: '25px', width: '25px', margin: '5px', float: 'left', cursor: row.ProgressBlockColor === '#3D9970' ? 'pointer' : 'default' }}>

                </div>
            </Tooltip>
        )
    }

    getGraderRow = (row) => {
        if (row.EventStatus === 'Is Completed' || row.EventStatus === 'Waiting for Grade' || row.EventStatus === 'Failing Grade' || row.EventStatus === 'Retake Event' || row.EventStatus === 'Is Graded') {
            return(
                <IconButton
                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                    onClick={(ev) => {
                        ev.stopPropagation();
                        this.handleRowClick(row);
                    }}
                >
                    <Icon>assignment</Icon>
                </IconButton>
            )
        }
        return null
    }

    getPageContent = (current_tab) => {
        const { student_gradebook, auth, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const auth_role = auth.user.role;
        const table_name = this.constructor.name;
        const studentEventList = student_gradebook.event_list;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        switch (current_tab) {
            case (0): // Course List
                {
                    return (
                        <ReactTable
                            style={{ position: 'absolute' }}
                            columns={[
                                {
                                    Header: "Lesson Name",
                                    accessor: "LessonName",
                                    Cell: row => (
                                        <TableCellTooltip
                                            item={row.original.LessonName}
                                            chars={20}
                                        />
                                    )
                                },
                                {
                                    Header: "Event Type",
                                    accessor: "EventType",
                                    maxWidth: 90
                                },
                                {
                                    Header: "Event Name",
                                    accessor: "EventName",
                                    Cell: row => (
                                        <TableCellTooltip
                                            item={row.original.EventName}
                                            chars={20}
                                        />
                                    )
                                },
                                {
                                    Header: "Event Date",
                                    accessor: "EventDate",
                                    maxWidth: 100
                                },
                                {
                                    id: 'EventIsGradable',
                                    Header: "Gradable",
                                    maxWidth: 70,
                                    accessor: row => row.EventIsGradable ? 'Yes' : 'No',
                                },
                                {
                                    id: 'EventIsRequired',
                                    Header: "Required",
                                    maxWidth: 65,
                                    accessor: row => row.EventIsRequired ? 'Yes' : 'No',
                                },
                                {
                                    Header: "Status",
                                    maxWidth: 100,
                                    id: 'Status',
                                    // accessor: "ProgressBlockColor"
                                    accessor: a => this.getStatusColumn(a)
                                },
                                {
                                    Header: "Event Score",
                                    maxWidth: 100,
                                    Cell: (row) => (
                                        Number(row.original.EventScore).toFixed(1) + ' / ' + Number(row.original.EventTotalScore).toFixed(1)
                                    )
                                },
                                {
                                    Header: "Final Grade",
                                    maxWidth: 100,
                                    // accessor: "GradebookScore",
                                    Cell: (row) => (
                                        Number(row.original.GradebookScore).toFixed(1) + ' / ' + Number(row.original.GradebookScore).toFixed(1)
                                    )
                                    // Cell: (row) => (
                                    //     <TextField
                                    //         id="GradebookScore"
                                    //         value={row.original.GradebookScore}
                                    //         onChange={this.handleScoreChange(row.original.gradebook_detail_id)}
                                    //         onBlur={this.handleScoreBlur(row.original.gradebook_detail_id)}
                                    //         margin="normal"
                                    //         variant="outlined"
                                    //         margin="dense"
                                    //         disabled={auth_role === "student"}
                                    //         type='number'
                                    //         inputProps={{
                                    //             min: 0.00,
                                    //             step: 1
                                    //         }}
                                    //     />
                                    // )
                                },
                                {
                                    Header: "Grade",
                                    maxWidth: 70,
                                    id: "Grade",
                                    accessor: a => this.getGraderRow(a)
                                }
                            ]}
                            data={studentEventList}
                            defaultPageSize={25}
                            pageSize={table_page_size[table_name]}
                            className="-striped -highlight"
                            noDataText="No Events Found"
                            defaultSorted={table_sort[table_name]}
                            onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                            filterable={true}
                            defaultFiltered={table_filter[table_name]}
                            onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                            onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                        />
                    );
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    render() {
        const { classes, student_gradebook } = this.props;
        const { current_tab } = this.state;
        const page_content = this.getPageContent(current_tab);

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24">
                        <h4>
                            {"Gradebook"}
                        </h4>
                        <h4>
                            Course Name: {student_gradebook.course_info.CourseName}
                        </h4>
                        <h4>
                            Student Name: {(student_gradebook.student_info.FirstName + " " + student_gradebook.student_info.LastName)}
                        </h4>
                    </div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Event List"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"gradebook"}
                                view_type={'detail'}
                                button_list={[
                                    {
                                        type: "back",
                                        onClick: () => this.props.history.goBack(),
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={page_content}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentGradebook: Actions.getStudentGradebook,
        updateGradebookScore: Actions.updateGradebookScore,
        saveGradebookScore: Actions.saveGradebookScore,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ gradebookApp, tableSort, auth }) {
    return {
        student_gradebook: gradebookApp.gradebook.student_gradebook,
        student_name: gradebookApp.gradebook.student_name,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentGradebook)));



// WEBPACK FOOTER //
// src/main/content/gradebook/StudentGradebook.js